﻿import { extend, getParent } from 'Furillo/modules/helpers.js';

export default class EsemContractModule {

    constructor(element, options) {

        const defaults = { };

        this.element = element;
        this.step = parseInt(element.getAttribute('data-contract-module-step'));
        this.options = extend(defaults, options);        

        //if (this.options.apiUrl.length === 0) {
        //    this.options.apiUrl = this.element.getAttribute('data-url');
        //}

        this.init();
    }

    stepOne() {
        const self = this;

        const choicesWrapper = self.element.querySelector('.choices');
        const consumptionElement = self.element.querySelector('.consumption input');

        choicesWrapper.querySelectorAll('button[data-consumption]').forEach(element => {           

            element.addEventListener('click', event => {
                event.preventDefault();

                let button = event.target;

                // This happens when we have nested elements within a button
                if (button.tagName !== 'BUTTON')
                    button = getParent(button, 'button');
                                   
                // Set active button
                choicesWrapper.querySelectorAll('button[data-consumption]').forEach(button => {
                    button.classList.remove('active');
                });
                button.classList.add('active');

                // Set value                
                consumptionElement.value = parseFloat(button.getAttribute('data-consumption'));
                document.getElementById('Order_Contract_ConsumptionName').value = button.getAttribute('data-consumption-name');
            });
        });
    }

    stepTwo() {
        const self = this;

        const form = getParent(self.element, 'form');

        const getSelectedAddOn = function(contractElement, fixed) {
            let value = { id: 0, name: '', extra: '' };

            let isFixedPrice = fixed ? 'true' : 'false';

            const element = contractElement.querySelector('.contract-addons input[type="radio"][data-isfixedprice="' + isFixedPrice + '"]:checked');
            if (!element)
                return value;

            value.id = parseInt(element.getAttribute('data-addonid'));
            value.name = contractElement.querySelector('.contract-addons label[for="' + element.getAttribute('id') + '"]').textContent;

            if (isNaN(value.id))
                value.id = 0;

            if (!value.name)
                value.name = '';

            var select = element.parentNode.querySelector('select:not(d-none)');
            if (select) {
                value.extra = select.value;
            }

            return value;
        };

        const getSelectedPeriod = function(contractElement) {
            let value = { id: 0, name: '' };

            const element = contractElement.querySelector('.contract-periods input[type="radio"]:checked');
            if (!element)
                return value;

            value.id = parseInt(element.getAttribute('data-periodid'));
            value.name = contractElement.querySelector('.contract-periods label[for="' + element.getAttribute('id') + '"]').textContent;

            if (isNaN(value.id))
                value.id = 0;

            if (!value.name)
                value.name = '';

            return value;
        };


        const updatePrices = function (contractElement) {

            let request = {
                contentId: parseInt(self.element.getAttribute('data-contentid')),
                contractId: parseInt(contractElement.getAttribute('data-contractid')),
                periodId: getSelectedPeriod(contractElement).id,
                addOnId: getSelectedAddOn(contractElement, false).id,
                fixedAddOnId: getSelectedAddOn(contractElement, true).id,
                contractStart: document.getElementById('Order_Contract_ContractStart').value,
                consumptionKwh: parseFloat(document.getElementById('Order_Contract_ConsumptionKwh').value)
            };
            
            fetch('/api/contractmodule/prices', {
                method: 'POST',
                mode: 'same-origin',
                cache: 'no-cache',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(request)
            }).then((response) => {
                return response.json();
            }).then((json) => {

                // Contract prices
                contractElement.querySelector('.contract-prices .price-data').innerHTML = json.contractPriceSummaryHtml;

                // Addons
                for (var i = 0; i < json.priceData.addOnPrices.length; i++) {
                    let addOnPrice = json.priceData.addOnPrices[i];
                                        
                    let span = contractElement.querySelector('.contract-addons .form-check span[data-addonid="' + addOnPrice.id + '"]');
                    if (!span)
                        continue;

                    span.textContent = '(' + addOnPrice.pricePerKwhFormatted + ')';
                }

                // Compare price
                contractElement.querySelector('.compare-price span.sek').textContent = json.priceData.unitPriceComparisonFormatted;
                contractElement.querySelector('.compare-price span.kwh').textContent = json.priceData.unitPriceComparisonKwhFormatted;
            }).catch(function (err) {
                console.warn('Something went wrong.', err);                
            });
        };

        const toggleAddOnExtras = function (radio) {

            getParent(radio, '.contract-addons').querySelectorAll('input[type="radio"] ~ select').forEach(element => {
                element.value = '';
                element.classList.add('d-none');
            });

            if (!radio.checked)
                return;

            var select = radio.parentNode.querySelector('select');
            if (!select)
                return;

            select.classList.remove('d-none');
        };

        // Event Listeners
        self.element.querySelectorAll('div[data-contractid]').forEach(contractElement => {

            // AddOns
            contractElement.querySelectorAll('.contract-addons input[type="radio"]').forEach(element => {

                element.addEventListener('click', event => {
                    // Client wants to use radio buttons but still be able to "un-check".
                    // Track the check state with data attribute in order to identify checked
                    // status (since 'checked' is always true at click and we can't use change)
                    let radio = event.target;
                    if (radio.hasAttribute('data-checked')) {
                        radio.removeAttribute('data-checked');
                        radio.checked = false;
                        toggleAddOnExtras(radio);
                        updatePrices(getParent(radio, 'div[data-contractid]'));
                        return;
                    }

                    let name = radio.getAttribute('name');
                    getParent(radio, '.contract-addons').querySelectorAll('input[type="radio"][name="' + name + '"]').forEach(radio => {
                        radio.removeAttribute('data-checked');
                    });
                    radio.setAttribute('data-checked', 'true');

                    toggleAddOnExtras(radio);
                    updatePrices(getParent(radio, 'div[data-contractid]'));
                });
            });

            // Periods
            contractElement.querySelectorAll('.contract-periods input[type="radio"]').forEach(element => {
                element.addEventListener('change', event => {
                    let radio = event.target;
                    updatePrices(getParent(radio, 'div[data-contractid]'));
                });
            });

            // Prices
            contractElement.querySelectorAll('.contract-prices > a').forEach(element => { 

                element.addEventListener('click', event => {
                    event.preventDefault();

                    let anchor = event.target;

                    if (anchor.getAttribute('aria-expanded') === 'false') {
                        anchor.setAttribute('aria-expanded', 'true');
                        return;
                    }

                    anchor.setAttribute('aria-expanded', 'false');
                });

            });

            // Submit
            contractElement.querySelector('.card-footer button.btn-primary').addEventListener('click', event => {
                event.preventDefault();

                document.getElementById('Order_Contract_SelectedContractId').value = contractElement.getAttribute('data-contractid');

                var selectedPeriod = getSelectedPeriod(contractElement);
                document.getElementById('Order_Contract_SelectedPeriodId').value = selectedPeriod.id;
                document.getElementById('Order_Contract_ContractPeriod').value = selectedPeriod.name;

                var selectedAddOn = getSelectedAddOn(contractElement, false);                
                document.getElementById('Order_Contract_SelectedAddOnId').value = selectedAddOn.id;
                document.getElementById('Order_Contract_AddOn').value = selectedAddOn.name;
                document.getElementById('Order_Contract_AddOnExtra').value = selectedAddOn.extra;

                var selectedFixedAddOn = getSelectedAddOn(contractElement, true);
                document.getElementById('Order_Contract_SelectedFixedAddOnId').value = selectedFixedAddOn.id;
                document.getElementById('Order_Contract_FixedAddOn').value = selectedFixedAddOn.name;
                
                form.submit();
            });

            // Initial
            updatePrices(contractElement);
        });
    }

    stepThree() {
        const self = this;
        const form = getParent(self.element, 'form');

        self.element.querySelectorAll('input[name="facilityhelp"]').forEach(radio => {
            radio.addEventListener('change', event => {
                if (radio.value == 'no-help') {
                    document.getElementById('facility-data-help').classList.add('d-none');
                    document.getElementById('facility-data').classList.remove('d-none');
                    document.getElementById('Order_FacilityIdHelpNeeded').value = 'False';
                    return;
                }
                document.getElementById('facility-data-help').classList.remove('d-none');
                document.getElementById('facility-data').classList.add('d-none');
                document.getElementById('Order_FacilityIdHelpNeeded').value = 'True';
            });
        });

        self.element.querySelectorAll('input[name="different-delivery-address"]').forEach(radio => {
            radio.addEventListener('change', event => {
                if (radio.value == 'true') {
                    document.getElementById('delivery-address').classList.remove('d-none');
                    document.getElementById('Order_DeliveryAddressDifferent').value = 'True';
                    return;
                }
                document.getElementById('delivery-address').classList.add('d-none');
                document.getElementById('Order_DeliveryAddressDifferent').value = 'False';
            });
        });

        document.getElementById('is-moving').addEventListener('change', event => {

            if (event.target.checked) {
                document.getElementById('is-moving-date').classList.remove('d-none');
                document.getElementById('Order_IsMoving').value = 'True';
                return;
            }

            document.getElementById('is-moving-date').classList.add('d-none');
            document.getElementById('Order_IsMoving').value = 'False';
        });

        document.getElementById('submit-campaign')?.addEventListener('click', event => { 
            form.action = form.action.replace('steg-4', 'steg-3');
            form.submit();
        });

        self.element.querySelectorAll('.contract-addons input[type="radio"]').forEach(element => {

            element.addEventListener('click', event => {
                // Client wants to use radio buttons but still be able to "un-check".
                // Track the check state with data attribute in order to identify checked
                // status (since 'checked' is always true at click and we can't use change)
                let radio = event.target;
                if (radio.hasAttribute('data-checked')) {
                    radio.removeAttribute('data-checked');
                    radio.checked = false;
                }

                if (radio.checked) {
                    document.getElementById('Order_Contract_SelectedFixedAddOnId').value = radio.getAttribute('data-addonid');
                    document.getElementById('Order_Contract_FixedAddOn').value = radio.getAttribute('data-name');
                }
                else {
                    document.getElementById('Order_Contract_SelectedFixedAddOnId').value = '';
                    document.getElementById('Order_Contract_FixedAddOn').value = '';
                }

                form.action = form.action.replace('steg-4', 'steg-3');
                form.submit();
            });
        });

        //getParent(radio, '.contract-addons').querySelectorAll('input[type="radio"] ~ select').forEach(element => {
        //    element.value = '';
        //    element.classList.add('d-none');
        //});

        //if (!radio.checked)
        //    return;

        //var select = radio.parentNode.querySelector('select');
        //if (!select)
        //    return;

        //select.classList.remove('d-none');

    }

    init() {
        const self = this;
        
        switch (self.step) {
            case 1:
                self.stepOne();
                break;
            case 2:
                self.stepTwo();
                break;
            case 3:
                self.stepThree();
                break;
            default:
                break;
        }

        const form = getParent(self.element, 'form');
        form.action = form.action + '?id=' + self.element.getAttribute('data-order-key');
    }    
}